import React, {useEffect, useRef, useState} from 'react';
import {Redirect, useHistory} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {CSVLink} from "react-csv";
import {
  Box,
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Menu,
  MenuItem,
  Slide,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import {createStyles, Theme, withStyles, WithStyles} from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import {TransitionProps} from '@material-ui/core/transitions';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import DoneIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import AddSharpIcon from '@material-ui/icons/AddSharp';
import Collapse from '@material-ui/core/Collapse';
import ExperienceLength from './experienceLength';
import ParticipantStatus from './participantStatus';
import ParticipantsTable from './participantsTable';
import {ParticipantModel} from '../../../../../interface/iParticipant';
import {
  addNewParticipantTag,
  deleteParticipantTag,
  getAllTagsByTypes,
  getManageHubs,
  getSessionParticipants,
  onUpdateSelectedHubs,
  removeParticipants,
  removeParticipantsTags,
  replaceParticipantsTags,
  tagApplied,
  updateParticipantsTags,
  updateParticipantTag,
} from '../../../../../store/actions/creator/creatorExperienceManager';
import {getLiveSessionParticipants} from '../../../../../store/actions/liveParticipants';
import CustomCheckBox from './component/CustomCheckbox';
import CustomSnackBar from './component/CustomSnackBar';
import UtilService from '../../../../../helper/service';
import {Helmet} from "react-helmet";
import ImmersionModal from '../../../../atoms/modals/commonModal';
import {AUTO_REFERESH_TIME_PARTICIPANT} from '../../../../../config/mock'
import CSVReader from 'react-csv-reader'
import {useStylesTooltip} from "../../../../../config/theme";
import Config from "../../../../../config/config";
import {Skeleton} from '@material-ui/lab';
import {BackDropAnalyzeLoading, Loading} from '../../../../atoms/commonLoadings';
import {experienceCategories} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import {Mixpanel} from "../../../../../helper/mixpanel";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F0F0F0',
    paddingTop: "30px",
    fontFamily: 'roboto-regular',
    height: '100%',
    overflowX: 'hidden',
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: "center",
    height: '100%'
  },
  content: {
    minHeight: '100%',
    padding: theme.spacing(4),
    paddingBottom: 100,
    paddingTop: theme.spacing(6),
    width: '100%',
    '@media (min-width: 2000px)': {
      width: 1600
    },
    '@media (max-width: 600px)': {
      padding: '55px 10px 10px 10px'
    },
  },
  contentView : {
    display: 'flex',
    '@media (max-width: 1232px)': {
      display: 'unset'
    },
  },
  contentItem : {
    marginRight:  20,
    '@media (max-width: 1232px)': {
      marginBottom: 24    
    },
  },
  menuItem: {
    padding: 0,
    '& .MuiPaper-root': {
      textDecoration: 'none'
    }
  },
  tagtools: {
    padding: theme.spacing(1),
    minWidth: "100%"
  },
  tagmodalwrap: {
    margin: 'auto',
    maxWidth: 500,
    borderRadius: 14,
  },
  tagmodalcontent: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    fontFamily: 'roboto-regular',
  },
  tagmodallistitem: {
    paddingLeft: 0,
    paddingRight: 0
  },
  tagmodalcheckbox: {
    padding: 0,
    margin: 0,
    minWidth: 35,
    textAlign: 'left'
  },
  tagmodalchecktitle: {
    color: '#697683',
    fontSize: 14,
    letterSpacing: -15
  },
  tagmodallist: {
    border: "1px solid #B2B9C0",
    borderRadius: 6,
    padding: theme.spacing(1),
    height: 250,
    overflowY: 'scroll'
  },
  tagmodaladdform: {
    marginTop: theme.spacing(1),
    width: '100%',
    minWidth: 37,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
	tagsearch: {
		marginTop: theme.spacing(1),
		width: '100%',
		minWidth: 37,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		marginBottom: theme.spacing(2)
	},
  tagmodaladdbtn: {
    minWidth: 37,
    height: 37,
    borderRadius: 6,
    backgroundColor: '#E5E5E5',
    boxShadow: 'none',
    padding: 0
  },
  loadingicon: {
    width: '20px!important',
    height: '20px!important'
  },
  tagmodaladdbtntxt: {
    fontFamily: 'roboto-regular',
    fontSize: 24,
    color: '#697683'
  },
  tagmodaladdinput: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    flex: 1,
    height: '100%',
    padding: 0,
    marginRight: theme.spacing(1),
    borderRadius: 6
  },
  tagmodalaction: {
    textAlign: 'right',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  tagmodalactionbtn: {
    borderRadius: 6,
    width: 91,
    height: 37,
    fontSize: 14,
    fontFamily: 'roboto-regular',
    boxShadow: 'none',
    color: '#FFFFFF',
    textTransform: 'none',
    background: '#0179EE',
    '&:hover': {
      background: '#0f9fef'
    }
  },
  delmodalactionbtn: {
    marginLeft: theme.spacing(1)
  },
  delemailtxt: {
    fontFamily: 'roboto-bold',
    color: '#212D40',
    fontSize: 18,
    textAlign: 'left'
  },
  delemaildesc: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#697683'
  },
  delemailwrap: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  delemailbtn: {
    backgroundColor: '#ED564A',
    borderRadius: 6,
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: 'white',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#ED4F59'
    }
  },
  delemailcancelbtn: {
    backgroundColor: '#F0F0F0',
    borderRadius: 6,
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    boxShadow: 'none',
    textTransform: 'none'
  },
  btn: {
    margin: 8
  },
  tagactionprimarybtn: {
    fontFamily: 'roboto-regular',
    backgroundColor: '#0179EE',
    borderRadius: 6,
    fontSize: 14,
    boxShadow: 'none',
    textTransform: 'none'
  },
  tagRemoveBtn: {
    backgroundColor: '#ED564A',
    borderRadius: 6,
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: 'white',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#ED4F59'
    }
  },
  tagactiondefaultbtn: {
    fontFamily: 'roboto-regular',
    backgroundColor: '#F0F0F0',
    borderRadius: 6,
    fontSize: 14,
    color: '#697683',
    boxShadow: 'none',
    textTransform: 'none'
  },
  tagactiontxtbtn: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#697683',
    boxShadow: 'none',
    textTransform: 'none'
  },
  collapseMenu: {
    boxShadow: '0px 0px 4px #00000033',
    background: 'white'
  },
  csvBtn: {
    textTransform: 'none',
    width: 100,
    height: 37,
    borderRadius: 6,
    backgroundColor: '#F0F0F0',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    '& input': {
      display: 'none'
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#d5d5d5',
      boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    },
  },
  csvLabel: {
    cursor: 'pointer',
    padding: 8
  },
  article: {
    textTransform: 'none',
    color: '#0179EE',
    cursor: 'pointer',
    textDecoration: 'none'
  },
  btnExport: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    textTransform: 'unset',
    marginRight: 20,
    marginLeft: 20,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 0'
  },
  btnText: {
    fontSize: 14,
    color: '#697683',
    textDecoration: "none",
  },
  header: {
    font: 'normal normal bold 20px/26px roboto-bold',
    letterSpacing: 0,
    marginBottom: 15,
    marginTop: 0
  },
  headerLabel: {
    margin: 0,
    color: '#212D40',
    font: 'normal normal bold 16px/26px roboto-bold'
  },
  headerText: {
    color: '#212D40',
    fontFamily: 'roboto-bold',
    fontSize: 20,
    marginTop: 12,
    marginLeft: 17,
    '@media (max-width: 374px)': {
      fontSize: 17
    }
  },
}));

const initParticipantModel = () => {
  return {
    last_step: '',
    last_step_at: '',
    participant_id: '',
    participant_status: '',
    recommended_action: '',
    tag_cloud: [],
	  tower_tag_cloud: [],
    temp_email: '',
    user_id: '',
    user_devices: '',
    indicator: '',
    phone: '',
    sensor: '',
    pid: ''
  }
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const styles = (theme: Theme) =>
  createStyles({
    tagmodalheader: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    closeButton: {
      color: theme.palette.grey[500],
      fontFamily: 'roboto-bold',
    },
    closeBtnIcon: {
      color: '#212D4080',
      width: 24,
      height: 24,
      fontFamily: 'roboto-bold'
    },
    modaltitle: {
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      color: '#212D40',
      textAlign: 'left'
    }
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.tagmodalheader} {...other}>
      <Typography variant="h5" className={classes.modaltitle}>{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon classes={{ root: classes.closeBtnIcon }} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2)
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function ParticipantsDashboard(props: any) {
  const classes = useStyles();

  const tooltipClasses = useStylesTooltip();
  const history = useHistory();

  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const apolloClient = useSelector((state: any) => state.apolloClient);

  const participants = useSelector((state: any) => state.experience.participants);

  const { stimulusList, managerHubList, managerLoading } = useSelector((state: any) => state.creatorExperienceManager);

  const [selRows, setSelRowData] = useState<ParticipantModel[]>([]);
  const [isShownTagTools, setShownTagTools] = useState(false);
  const [isShownTagModal, setShownTagModal] = useState(false);
  const [checked, setChecked] = useState([0]);
  const [isShownSnackAlert, setShownSnackAlert] = useState(false);
  const [isShownDelModal, setShownDelModal] = useState(false);
  const [allTags, handleAllTags] = useState<any[]>([]);
  const [tempAllTag, handleTempAllTags] = useState<any[]>([]);
  const [newTagName, handleNewTagName] = useState('');
  const [searchTagName, setSearchTagName]=useState('')
  const [loadingAddTag, handleLoadingAddTag] = useState(false);
  const [isAddTagError, handleAddTagError] = useState(false);
  const [snackAlertMsg, handleSnackMsg] = useState('');
  const [isLoadingTags, handleLoadingTags] = useState(false);
  const [isLoadingDelParts, handleLoadingDelParts] = useState(false);
  const [snackAlertType, handleSnackAlertType] = useState('');
  const [isShownUpdateTagLoading, handleShownUpdateTagLoading] = useState(false);
  const [csvData, handleCsvData] = useState<any[]>([]);
  const [editTag, handleEditTag] = useState(false);
  const [deleteTag, setDeleteTag] = useState('');
  // participant will be selected when click dot left menu on each rows
  const [participant, setParticipant] = useState<ParticipantModel>(initParticipantModel);
  const [isAdding, setIsAdding] = useState(true);
  const [showSelectedTags, setShowSelectedTags] = useState([]);
  const [isAllowApply, setIsAllowApply] = useState(false);
  const [recommendTags, setRecommendTags] = useState(false);

  const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const session_code = props.match.params.session_code;
  const [randomID, setRendomId] = useState(1);
  const [isMultiple, setIsMultiple] = useState(false);
  const childRef = useRef<any>(null);
  const parseOptions = {
    header: false,
    skipEmptyLines: true
  };
  const noMatchMsg = 'Darn, it looks like we can’t match any of the participants in this file. Ensure you have the correct participant emails or ID in the file.';
  const wrongFileType = 'Hey! It seems like your file is the wrong file type. Make sure you are saving it as a CSV file and try reuploading.';
  const wrongHeader = 'Whoops, it looks like you are missing a column or have the wrong column name. Please double-check check our file before trying to reupload.';
  const noNewTags = 'Shucks, it seems there are no new tags in this file. Please make sure you have updated your file with the tags you would like to import and try again.';

  const [csvHeadersWithEmail, setCSVHeadersWithEmail] = useState([
    { label: "No", key: "no" },
    { label: "Participant Email", key: "temp_email" },
    { label: "Pass through", key: "pass_through" },
    { label: "Status", key: "participant_status" },
    { label: "Last Step", key: "last_step" },
    { label: "Time Of Last Step", key: "last_step_at" },
    { label: "Phone", key: "phone" },
    { label: "Sensor", key: "sensor" },
  ]);
  const [csvHeadersWithDeviceId, setCSVHeadersWithDeviceId] = useState([
    { label: "No", key: "no" },
    { label: "Identifier", key: "temp_email" },
    { label: "Pass through", key: "pass_through" },
    { label: "Status", key: "participant_status" },
    { label: "Last Step", key: "last_step" },
    { label: "Time Of Last Step", key: "last_step_at" },
    { label: "Phone", key: "phone" },
    { label: "Sensor", key: "sensor" },
  ]);

  useEffect(() => {
		if (loginUserData && loginUserData.role_access) {
			if (loginUserData.role_access.length) {
        const _csvHeadersWithEmail = [...csvHeadersWithEmail];
        const _csvHeadersWithDeviceId = [...csvHeadersWithDeviceId];
				const recommend_tags = loginUserData.role_access.find((val: any) => val.access_name === "recommend_tags");
				if (recommend_tags && recommend_tags.access_value) {
					setRecommendTags(true);
          if (!_csvHeadersWithEmail.find((obj: any) => obj.key === "tower_tag_cloud")) {
            _csvHeadersWithEmail.push({label: "Tower Tags", key: "tower_tag_cloud"});
            _csvHeadersWithEmail.push({ label: "Tag 1", key: "tag_0" });
            setCSVHeadersWithEmail(_csvHeadersWithEmail);
          }
          if (!_csvHeadersWithDeviceId.find((obj: any) => obj.key === "tower_tag_cloud")) {
            _csvHeadersWithDeviceId.push({label: "Tower Tags", key: "tower_tag_cloud"});
            _csvHeadersWithDeviceId.push({ label: "Tag 1", key: "tag_0" });
            setCSVHeadersWithDeviceId(_csvHeadersWithDeviceId);
          }
				} else {
          _csvHeadersWithEmail.push({ label: "Tag 1", key: "tag_0" });
          _csvHeadersWithDeviceId.push({ label: "Tag 1", key: "tag_0" });
          setCSVHeadersWithEmail(_csvHeadersWithEmail);
          setCSVHeadersWithDeviceId(_csvHeadersWithDeviceId);
        }
			}
		}
    dispatch(experienceCategories(apolloClient.client));
	}, []);

  useEffect(() => {
    if (participants && participants.session) {
      const session_id = Number(participants.session['session_id']);
      const request: any = {session_id};
      if (loginUserData.department_id) {
        request['department_id'] = Number(loginUserData.department_id);
      }
      dispatch(getManageHubs(apolloClient.client, request));
    }
  }, [participants]);

  const queryStringOverview = new URLSearchParams(props.history.location.search).get("overview");

  useEffect(() => {
    history.push(window.location.pathname)
  }, [queryStringOverview]);

  useEffect(() => {
    if (!selRows.length) setShownTagTools(false);
    else setShownTagTools(true);
  }, [selRows]);

  useEffect(() => {
    if (!stimulusList.length) return;
  }, [stimulusList]);

  useEffect(() => {
    if (participant.participant_id && !isShownDelModal) {
      showTagModal(true);
    }
  }, [participant.participant_id]);

  useEffect(() => {
    const tagData: any = editTag;
    if (tagData.tagName) {
      handleNewTagName(tagData.tagName)
    }
  }, [editTag]);

	useEffect(() => {
		handleTempAllTags(allTags)
	}, [allTags])

  useEffect(() => {
    const getParticipants = () => {
      if (session_code) {
        dispatch(getSessionParticipants(apolloClient.client, { session_code, }, () => { }));
      }
    };
    getParticipants();
  }, []);

  useEffect(() => {
    if (!managerLoading && managerHubList.length > 0) {
      const checkedHubs = managerHubList.filter((hub: any) => hub.is_associate);
      const result = checkedHubs.map((hub: any) => {
        return {
          hub_id: hub.hub_id
        }
      });
      dispatch(onUpdateSelectedHubs(result));
    }
  }, [managerHubList, managerLoading]);

  useEffect(() => {
    const getLiveParticipants = () => {
      if (session_code) {
        dispatch(getLiveSessionParticipants(apolloClient.client, { session_code, }));
      }
    };

    const interval = setInterval(() => getLiveParticipants(), AUTO_REFERESH_TIME_PARTICIPANT);
    return () => {
      clearInterval(interval);
    }
  }, []);

  const regetSessionParticipants = async () => {
    try {
      if (session_code) {
        dispatch(getSessionParticipants(apolloClient.client, { session_code: session_code, }, (data: any) => {
          if (data) {
            setTimeout(() => {

            }, 3000)
          }
        }));
      }

    } catch (error) {
      showSnackAlert('Getting Failed! Please try again later!', 'error');
    }
  };

  const getAllParticipantsTags = async (updateChecked: boolean, isAdd?: boolean, newItemtag?: number) => {
    try {
      handleLoadingTags(true);
      const request: any = {
        type: 1,
        department_id: loginUserData.department_id
      };
      const tagsRes = await getAllTagsByTypes(apolloClient.client, request);
      let allTagList = [];
      const checkedArr: any[] = [];
      if (tagsRes.data.viewTagsByTypes) allTagList = tagsRes.data.viewTagsByTypes;

      let extTagArray: string[] = [];
      if (participant && participant.tag_cloud && participant.tag_cloud.length > 0) {
        const tagNames = UtilService.getParsedTagArray(participant.tag_cloud);
        extTagArray = extTagArray.concat(tagNames);
      } else {
        if (selRows.length > 0) {
          selRows.forEach(sp => {
            if (sp.tag_cloud && sp.tag_cloud.length > 0) {
              const tagNames = UtilService.getParsedTagArray(sp.tag_cloud);
              extTagArray = extTagArray.concat(tagNames);
            }
          });
        }
      }
      allTagList.forEach((t: any) => {
        if (extTagArray.indexOf(t.tagName) !== -1) checkedArr.push(t.tagId);
        if (newTagName && newTagName === t.tagName && !checkedArr.includes(t.tagId)) {
          checkedArr.push(t.tagId)
        }
        if (showSelectedTags.length > 0 && !checkedArr.includes(t.tagId)) {
          showSelectedTags.map((value: any) => {
            if (value.toLowerCase() === t.tagName.toLowerCase()) {
              checkedArr.push(t.tagId)
            }
          })
        }
      });
		if (updateChecked) setChecked(checkedArr);
		if (!isAdd || selRows.length > 0) {
			if (isMultiple && newItemtag) {
				setChecked([newItemtag]);
			} else {
				setChecked([])
			}
      }
      handleAllTags(allTagList);
      handleLoadingTags(false);
    } catch (error) {
      showSnackAlert('Getting Failed! Please try again later!', 'error');
    }
  };

  const showTagModal = (isAdding: boolean) => {
    setIsAdding(isAdding);
    dispatch(tagApplied(false));
    getAllParticipantsTags(true,isAdding);
    setShownTagModal(true);
    localStorage.setItem("isAdding", isAdding.toString())
  };

  const hideTagModal = () => {
    handleNewTagName('');
	setSearchTagName('')
    setParticipant(initParticipantModel);
    setShownTagModal(false);
    handleLoadingAddTag(false);
    setIsAllowApply(false);
    handleAddTagError(false);
    setShowSelectedTags([]);
    setIsMultiple(true);
  };

  const handleToggle = (value: number) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    let filtered = [];
    // remove duplicate from array
    filtered = newChecked.filter((a, b) => newChecked.indexOf(a) === b);
    setChecked(filtered);
    setIsAllowApply(true)
  };

  const showSnackAlert = (msg: string, type: string) => {
    handleSnackMsg(msg);
    handleSnackAlertType(type);
    setShownSnackAlert(true);
  };

  const hideSnackAlert = () => {
    setShownSnackAlert(false);
  };

  const handleReleaseSelRows = () => {
    setSelRowData([]);
    if (childRef !== null && childRef.current) {
      childRef.current.setEmptySelParts();
    }
  };

  const onChangeTagName = (e: any) => {
    e.preventDefault();
    const value = e.target.value;
    handleNewTagName(value);
    handleAddTagError(value.length === 0);
  };

	const onSearchTagName = (e: any) => {
		const value = e.target.value;
		setSearchTagName(value)
		let searchTagList = [];
		searchTagList = allTags.filter((item => item.tagName && item.tagName.toLowerCase().indexOf(value.length > 0 ? value.toLowerCase() : value) !== -1));
		if (value) {
			handleTempAllTags(searchTagList)
		} else {
			handleTempAllTags(allTags)
		}
	};

  const handleAddTagSubmit = async (e: any) => {
    e.preventDefault();
    setSearchTagName('');
    if (!newTagName || newTagName.trim().length === 0 || newTagName.trim() === '-') {
      handleAddTagError(true);
      return;
    }

    Mixpanel.identify(loginUserData.user_id);
    Mixpanel.track('add_tag', {
      'Experience Type': `${participants.session.session_type}`,
      'Experience Owner': `${participants.session.user.first_name} ${participants.session.user.last_name}`
    });
    Mixpanel.people.set({
      $email: loginUserData.username,
      $first_name: loginUserData.first_name,
      $last_name: loginUserData.last_name,
      $team: loginUserData.department_name,
      $type: loginUserData.role_alias
    });

    try {
      handleLoadingAddTag(true);
      const alreadyExistsTag = allTags.filter(function (tag) {
        if (tag.tagName.toLowerCase() === newTagName.toLowerCase()) {
          return tag;
        }
      });
      if (alreadyExistsTag.length > 0) {
        setChecked([...checked, alreadyExistsTag[0].tagId]);
        showSnackAlert("Tag already existed and selected.", 'error');
        handleLoadingAddTag(false);
        handleNewTagName('');
        handleEditTag(false);
        return false
      }
      if (editTag) {
        const tagData: any = editTag;
        const request: any = {
          tagName: newTagName,
          tagDescription: tagData.tagDescription ? tagData.tagDescription : "",
          tagId: parseFloat(tagData.tagId),
          user_id: parseFloat(loginUserData.user_id),
          department_id: loginUserData.department_id,
        };
        const updateTagResult = await updateParticipantTag(apolloClient.client, request);
        if (updateTagResult.data.updateTag.status === true) {
          const resData = updateTagResult.data.updateTag;
          showSnackAlert(resData.message, 'success');
          handleEditTag(false);
          getAllParticipantsTags(false);
        } else {
          showSnackAlert(updateTagResult.data.updateTag.message, 'error');
        }
      } else {
        const addTagResult = await addNewParticipantTag(loginUserData.department_id, newTagName, parseFloat(loginUserData.user_id), apolloClient.client);
        if (addTagResult.data.addTag.status === true) {
          const resData = addTagResult.data.addTag;
          showSnackAlert(resData.message, 'success');
          setChecked([...checked, addTagResult.data.addTag.data.tagId]);
          getAllParticipantsTags(true, true, addTagResult.data.addTag.data.tagId);
        } else {
          showSnackAlert(addTagResult.data.addTag.message, 'error');
        }
      }
    } catch (error) {
      showSnackAlert(JSON.stringify(error), 'error');
    }
    handleNewTagName('');
    handleLoadingAddTag(false);
    setIsAllowApply(true);
  };

  const handleDeleteTag = async () => {
    Mixpanel.identify(loginUserData.user_id);
    Mixpanel.track('remove_tag', {
      'Experience Type': `${participants.session.session_type}`,
      'Experience Owner': `${participants.session.user.first_name} ${participants.session.user.last_name}`
    });
    Mixpanel.people.set({
      $email: loginUserData.username,
      $first_name: loginUserData.first_name,
      $last_name: loginUserData.last_name,
      $team: loginUserData.department_name,
      $type: loginUserData.role_alias
    });

    const tagId = deleteTag;
    const user_id = loginUserData.user_id;
    setDeleteTag('');
	  setSearchTagName('');
    try {
      handleLoadingTags(true);
      const deleteTagResult = await deleteParticipantTag(apolloClient.client, parseInt(tagId), user_id);
      if (deleteTagResult.data.deleteTag.status === true) {
        const resData = deleteTagResult.data.deleteTag;
        showSnackAlert(resData.message, 'success');
        getAllParticipantsTags(false);
        setChecked(checked.filter((item: any) => item.tagId !== tagId));
      } else {
        showSnackAlert(deleteTagResult.data.deleteTag.message, 'error');
      }
    } catch (error) {
      showSnackAlert(JSON.stringify(error), 'error');
    }
    handleLoadingTags(false);
  };

  const handleCopyEmails = () => {
    showSnackAlert(`${selRows.length} email have been copied to your clipboard.`, 'success')
  };

  const handleDeleteParticipants = async () => {
    if (participant && participant.participant_id) {  // if participant is selected using dot left menu (delete)
      const participantList = [];
      participantList.push(participant);
      await deleteParticipants([...participantList]);
    } else { // if participants are selected using checkbox
      if (selRows.length === 0) {
        setShownDelModal(false);
        return;
      }
      await deleteParticipants(selRows);
    }
  };

  const deleteParticipants = async (participantList: any) => {
    const ids = participantList.map((p: any) => {
      return p.participant_id
    });
    const emails = participantList.map((p: any) => {
      return p.temp_email
    });
    if (ids.length === 0) return;
    try {
      handleLoadingDelParts(true);
      const removeRes = await removeParticipants(emails, session_code, apolloClient.client);
      handleLoadingDelParts(false);
      if (removeRes.data.removeParticipants) {
        // temper action
        if (!removeRes.data.removeParticipants.status) {
          showSnackAlert(removeRes.data.removeParticipants.message, 'error');
        } else {
          // const newparts = participants.participants.filter((p: any) => ids.indexOf(p.participant_id) === -1);
          // participants.participants = newparts;
          showSnackAlert(removeRes.data.removeParticipants.message, 'success');
        }
        setParticipant(initParticipantModel);
        setShownDelModal(false);
      }
    } catch (error) {
      showSnackAlert('Removing is failed! Try again later!', 'error');
      setParticipant(initParticipantModel);
      setShownDelModal(false);
    }
  };

  const handleEditTagsParticipants = async () => {
	setSearchTagName('')
    if (participant && participant.participant_id) { // if participant is selected using dot left menu (edit tags)
      const participantList = [];
      participantList.push(participant);
      await editTags([...participantList])
    } else { // if participants are selected using checkbox
      if (selRows.length === 0) {
        return hideTagModal();
      }
      await editTags(selRows);
    }
  };

  const editTags = async (participantList: any) => {
    handleShownUpdateTagLoading(true);
    const participantIds = participantList.map((p: any) => parseFloat(p.participant_id));
    let selTags: any[] = [];
    let tag_cloud: any[] = [];

    if (checked.length) {
      if (checked[0] === Number(0)) checked.shift();
      selTags = allTags.filter(t => checked.indexOf(t.tagId) !== -1);
    }

    if (selTags.length) {
      const selTagNameArr = selTags.map((t) => Object.assign({}, { tag_name: t.tagName }));
      tag_cloud = [...selTagNameArr];
    }
    
    const request = {
      tag_cloud,
      participant_id: participantIds,
      session_code: session_code,
      getPreviousTags:isMultiple
    };

    if (isAdding) { // add tags
      const resData = await updateParticipantsTags(apolloClient.client, request);

      if (resData.data.updateTags) {
        const status = resData.data.updateTags.status;
        if (status === true) {
          // let oldParticipants = participants.participants;
          // oldParticipants.forEach((p: ParticipantModel) => {
          //   if (participantIds.indexOf(parseInt(p.participant_id)) !== -1) {
          //     p.tag_cloud = p.tag_cloud ? removeDuplicatedTags(p.tag_cloud.concat(tag_cloud)) : removeDuplicatedTags(tag_cloud);
          //   }
          // });
          // participants.participants = oldParticipants;
          regetSessionParticipants()
        }
        showSnackAlert(resData.data.updateTags.message, status ? 'success' : 'error');
      }
    } else { // remove tags
      const removeArray: any = [];
      if (checked && checked.length) {
        checked.map(tagId => {
          if (tagId) {
            const getSelected = allTags.find((obj:any)=>obj.tagId === tagId)
            if (getSelected) {
              removeArray.push({ tag_name: getSelected.tagName })
            }
          }
        })
      }
      request.tag_cloud = removeArray;
      const resData = await removeParticipantsTags(apolloClient.client, request);

      if (resData.data.removeTags) {
        const status = resData.data.removeTags.status;
        if (status === true) {
          // let oldParticipants = participants.participants;
          // oldParticipants.forEach((p: ParticipantModel) => {
          //   if (participantIds.indexOf(parseInt(p.participant_id)) !== -1) {
          //     p.tag_cloud = removeTagsFromOrigin(p.tag_cloud, tag_cloud);
          //   }
          // });
          // participants.participants = oldParticipants;
          regetSessionParticipants()
        }
        showSnackAlert(resData.data.removeTags.message, status ? 'success' : 'error');
      }
    }
    dispatch(tagApplied(true));
    setParticipant(initParticipantModel);
    setChecked([]);
    setShownTagModal(false);
    handleShownUpdateTagLoading(false);
  };

  const handleCSVDownload = (type: any) => {
    if (!selRows.length) return;
    let tagCount = 0;
    selRows.map((participant: any) => {
      if (participant.tag_cloud && participant.tag_cloud.length > tagCount)
        tagCount = participant.tag_cloud.length;
    });
    const _csvHeadersWithEmail = [...csvHeadersWithEmail];
    const _csvHeadersWithDeviceId = [...csvHeadersWithDeviceId];
    for (let i = 0; i < tagCount; i++) {
      if (type === "email") {
        if (!(_csvHeadersWithEmail.find((header: any) => header.key === `tag_${i}`))) {
          _csvHeadersWithEmail.push({label: `Tag ${i + 1}`, key: `tag_${i}`});
        }
      } else {
        if (!(_csvHeadersWithDeviceId.find((headerdevice: any) => headerdevice.key === `tag_${i}`))) {
          _csvHeadersWithDeviceId.push({label: `Tag ${i + 1}`, key: `tag_${i}`});
        }
      }
    }

    setCSVHeadersWithEmail(_csvHeadersWithEmail);
    setCSVHeadersWithDeviceId(_csvHeadersWithDeviceId);
    const downData: any = [];
    
    selRows.map((p: any, index: number) => {
      downData.push({
        no: (index + 1),
        temp_email: (type === 'email') ? p.temp_email : p.identifier,
        pass_through: p.passthrough ? p.passthrough : "-", 
        participant_status: UtilService.formattingString(p.participant_status),
        last_step: UtilService.formattingString(p.last_step),
        last_step_at: (p.last_step === 'ADDED' || p.last_step === 'NEW_USER' || p.last_step === 'NO_SENSOR_REGISTERED') ? "-" : UtilService.getParticipantDateFormatString(p.last_step_at),
        phone: UtilService.getPhoneSensor(p.user_devices, 'phone'),
        sensor: UtilService.getPhoneSensor(p.user_devices, 'sensor'),
        tower_tag_cloud: p.tower_tag_cloud ? UtilService.getParsedTowerTags(p.tower_tag_cloud) : '-',
      });
      if (tagCount) {
        for (let i = 0; i < tagCount; i++) {
          downData[index][`tag_${i}`] = p?.tag_cloud?.[i]?.tag_name ? p?.tag_cloud?.[i]?.tag_name : '-';
        }
      } else {
        downData[index][`tag_0`] = '-';
      }
    });
    handleCsvData(downData.sort(() => Math.random() - 0.5).map((obj: any, index: any) => { obj.no = index + 1; return obj; }));
    handleMenuRightClose();
  };

  const dotEditTags = (p: any) => {
    if (p.tag_cloud && p.tag_cloud.length > 0) {
      const tagNameArray: any = [];
      p.tag_cloud.map((value: any) => {
        tagNameArray.push(value.tag_name);
      });
      setShowSelectedTags(tagNameArray);
    }
    setParticipant(p);
    setIsMultiple(false)
  };

  const dotRemoveParticipant = (p: any) => {
    setParticipant(p);
    setShownDelModal(true);
  };

  const onShowError = (message: string) => {
    showSnackAlert(message, 'error');
  };

  if (!session_code || session_code !== currentSessionCode) {
    return <Redirect to='/creator/dashboard' />
  }

  const handleForceCSV = async (rows: any, fileInfo: any) => {
    setRendomId(randomID + 1);
    const fileType = fileInfo['type'];
    if (fileType !== 'text/csv') {
      onShowError(wrongFileType);
      return;
    }

    if (rows && rows.length > 1) {
      const reqData: any = [];
      const matchedParticipants = [];
      // check header of csv
      const header = rows[0];
      const finalIndex = recommendTags ? 9 : 8;
      for (let i = 0; i < finalIndex; i ++) {
        if (
          header[i].toLowerCase() !== csvHeadersWithEmail[i].label.toLowerCase()
          && header[i].toLowerCase() !== csvHeadersWithDeviceId[i].label.toLowerCase()
        ) {
          onShowError(wrongHeader);
          return;
        }
      }

      // read data except header
      for (let i = 1; i < rows.length; i ++) {
        const row = rows[i];
        if (row[1]) { // participant email or identifier
          const email_or_identifier = row[1];
          const participant = participants && participants.participants &&
            participants.participants.find((obj: any) => (
              (obj.temp_email && obj.temp_email.toLowerCase() === email_or_identifier.toLowerCase())
              || (obj.identifier && obj.identifier.toLowerCase() === email_or_identifier.toLowerCase())
            ));
          if (participant) {
            matchedParticipants.push(participant);
            const allTags: any = [];
            for (let i = (recommendTags ? 9 : 8); i < row.length; i++) {
              const csvTag = row[i];
              if (!allTags.find((tag: any) => tag.tag_name.toLowerCase() === csvTag.toLowerCase().trim())) {
                allTags.push({ tag_name: csvTag != "-" ? csvTag.trim() : "" })
              }
            }

            if (allTags.length) {
              const data = {
                tag_cloud: allTags,
                participant_id: parseFloat(participant.participant_id),
                session_code: session_code
              };
              reqData.push(data)
            }
          }
        }
      }

      if (matchedParticipants.length === 0) { // if there isn't any matched participants, show message.
        onShowError(noMatchMsg);
        return;
      }

      if (reqData.length) {
        const req = {
          participants_data: reqData
        };
        const resData = await replaceParticipantsTags(apolloClient.client, req);
        if (resData.data.replaceParticipantsTags) {
          const status = resData.data.replaceParticipantsTags.status;
          if (status === true) {
            regetSessionParticipants()
          }
          showSnackAlert(resData.data.replaceParticipantsTags.message, status ? 'success' : 'error');
        } else {
          onShowError('Oops. Something went wrong. Please try again!');
        }
      } else {
        onShowError(noNewTags);
      }
    } else {
      onShowError(noNewTags);
    }
  };

  const downloadRef = useRef(null);
  const [openRightMenu, setOpenRightMenu] = useState(false);

  const handleMenuRightOpen = () => {
    setOpenRightMenu(true);
  };

  const handleMenuRightClose = () => {
    setOpenRightMenu(false);
  };

  return (
    (session_code && session_code === currentSessionCode) && (
      <div className={participants === null ? classes.loading : classes.root} style={{ paddingTop: 37 }}>
        <Helmet title="Experience Manager" />
        <BackDropAnalyzeLoading loading={!participants} />

        {participants ?
          <div>
            <Collapse in={isShownTagTools} className='participant-subHeader'>
              <Box className={classes.collapseMenu} display="flex" justifyContent="space-between" alignItems="center" p={1} pt={1} pb={0}>
                <Box display="flex" alignContent="flex-start" alignItems="center">
                  <Box p={1}><Button id='add_tag_button' variant="contained" className={classes.tagactionprimarybtn} color="primary" onClick={() => {showTagModal(true);setIsMultiple(true)}}>Add Tags</Button></Box>
                  <Box p={1}><Button id='remove_tag_button' variant="contained" className={classes.tagRemoveBtn} color="secondary" onClick={() => showTagModal(false)}>Remove Tags</Button></Box>
                  <CopyToClipboard
                    text={selRows.map(r => r.temp_email).toString()}
                    onCopy={handleCopyEmails}>
                    <Box p={1}><Button id='copy_email_button' variant="contained" className={classes.tagactiondefaultbtn}>Copy Emails</Button></Box>
                  </CopyToClipboard>
                  <Box p={1}><Button id='remove_participant_button' className={classes.tagactiontxtbtn} onClick={() => setShownDelModal(true)}>Remove Participants</Button></Box>
                </Box>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Box p={1}><Button className={classes.tagactiontxtbtn} onClick={handleReleaseSelRows}>Clear Selected</Button></Box>
                  {(participants && participants.session?.session_status !== 'COMPLETED') &&
                    <Box p={1} key={randomID}>
                      <CSVReader
                        cssClass={classes.csvBtn}
                        cssLabelClass={classes.csvLabel}
                        label="Import Tags"
                        onFileLoaded={(data, fileInfo) => handleForceCSV(data, fileInfo)}
                        parserOptions={parseOptions}
                      />
                    </Box>
                  }
                  <Box p={1}>
                    <Tooltip classes={tooltipClasses} title="Export to CSV" placement="bottom" arrow>
                      <IconButton
                        aria-label="download"
                        size="medium"
                        ref={downloadRef}
                        onClick={handleMenuRightOpen}
                      >
                        <img src={'/assets/icons/download_icon.svg'} alt="CSV Download" />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadRef.current}
                      elevation={1}
                      onClose={handleMenuRightClose}
                      open={openRightMenu}
                      PaperProps={{
                        style: { width: 'auto', marginTop: 50, borderRadius: 12 }
                      }}
                    >
                      <MenuItem
                        className={classes.menuItem}
                        onClick={() => handleMenuRightClose}
                      >
                        <div className={classes.btnExport}>
                          <CSVLink className={classes.btnText} data={csvData} headers={csvHeadersWithEmail} onClick={() => handleCSVDownload('email')} filename={`${UtilService.generateCsvFileName(participants)}_participants_email.csv`}>
                            By Email
                          </CSVLink>
                        </div>
                      </MenuItem>
                      <MenuItem
                        className={classes.menuItem}
                        onClick={() => handleMenuRightClose}
                      >
                        <div className={classes.btnExport} >
                          <CSVLink className={classes.btnText} data={csvData} headers={csvHeadersWithDeviceId} onClick={() => handleCSVDownload('deviceId')} filename={`${UtilService.generateCsvFileName(participants)}_participants_deviceId.csv`}>
                            By Device ID
                          </CSVLink>
                        </div>
                      </MenuItem>
                    </Menu>
                  </Box>
                </Box>
              </Box>
            </Collapse>

            <div className={classes.content}>
              <div className={classes.contentView} >
                {!isMobile && <div className={classes.contentItem}>
                  <ExperienceLength session={participants.session} />
                </div>}
                <div style={{ flex: 1 }}>
                  <ParticipantStatus
                    isMobile={isMobile}
                    session={participants.session}
                    showCollapseMenu={isShownTagTools}
                    session_code={session_code}
                    importCSV={handleForceCSV}
                  />
                </div>
              </div>
              <ParticipantsTable
                ref={childRef}
                isMobile={isMobile}
                setTagToolsTrigger={setSelRowData}
                dotEditTags={(participant: any) => dotEditTags(participant)}
                dotRemoveParticipant={(participant: any) => dotRemoveParticipant(participant)}
              />
            </div>

            <Dialog
              open={isShownTagModal}
              TransitionComponent={Transition}
              keepMounted
              fullWidth={true}
              classes={{
                paper: classes.tagmodalwrap
              }}
              onClose={hideTagModal}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle id="alert-dialog-slide-title" onClose={hideTagModal}>{`${isAdding ? 'Add' : 'Remove'} Participant Tags`}</DialogTitle>
              <DialogContent dividers>
                <Container maxWidth="md">
                  {!isLoadingTags && allTags.length > 0 && (
                    <div className={classes.tagsearch}>
                      <TextField
                        variant="outlined"
                        size="small"
                        required
                        disabled={isLoadingTags}
                        placeholder={"Search Tag ..."}
                        InputProps={{ className: classes.tagmodaladdinput }}
                        classes={{
                            root: classes.tagmodaladdinput
                        }}
                        name="search_tag"
                        value={searchTagName}
                        onChange={onSearchTagName}
                      />
                    </div>)
                  }
                  <div className={classes.tagmodalcontent}>
                    {isLoadingTags && (
                      <Loading style={{ width: 70, height: 70, margin: 'auto' }}/>)}
                    {!isLoadingTags && (
                      <div>
                        {!tempAllTag.length && (
                          <div>No available tags, please add new tags</div>
                        )}
                        {tempAllTag.length > 0 && (
                          <List className={classes.tagmodallist}>
                            {
                              tempAllTag.map((value: any) => {
                                const labelId = `checkbox-list-label-${value.tagId}`;
                                return (
                                  <ListItem key={value.tagId} role={undefined} dense button className={classes.tagmodallistitem} onClick={handleToggle(value.tagId)}>
                                    <ListItemIcon>
                                      <CustomCheckBox
                                        edge="start"
                                        color="primary"
                                        checked={checked.indexOf(value.tagId) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                        className={classes.tagmodalcheckbox}
                                        inputProps={{ 'aria-labelledby': labelId }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText className={classes.tagmodalchecktitle} id={labelId} primary={value.tagName} />
                                    <ListItemSecondaryAction>
                                      <IconButton edge="end" aria-label="edit" onClick={() => { handleEditTag(value) }}>
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                      <IconButton edge="end" aria-label="edit" onClick={() => { setDeleteTag(value.tagId) }}>
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </ListItemSecondaryAction>
                                  </ListItem>
                                );
                              })
                            }
                          </List>
                        )}
                      </div>
                    )}
                  </div>
                  <form className={classes.tagmodaladdform} onSubmit={handleAddTagSubmit} noValidate autoComplete="off">
                    <TextField
                      error={isAddTagError}
                      // defaultValue="Hello World"
                      helperText={isAddTagError ? 'Tag name is required.' : ''}
                      variant="outlined"
                      size="small"
                      required
                      disabled={isLoadingTags}
                      placeholder={!editTag ? "Add a new Tag ..." : "Update Tag..."}
                      InputProps={{ className: classes.tagmodaladdinput }}
                      classes={{
                        root: classes.tagmodaladdinput
                      }}
                      name="participant_tag"
                      value={newTagName}
                      onChange={onChangeTagName}
                    />
                    {isLoadingTags && (
                      <Button variant="contained"
                        disabled
                        className={classes.tagmodaladdbtn}>
                        <AddSharpIcon className={classes.tagmodaladdbtntxt} />
                      </Button>
                    )}
                    {!isLoadingTags && (
                      <Button variant="contained"
                        type="submit"
                        disabled={loadingAddTag}
                        className={classes.tagmodaladdbtn}
                      >
                        {loadingAddTag &&
                          <Loading style={{ width: 37, height: 37 }}/>}
                        {!loadingAddTag && (!editTag ? <AddSharpIcon className={classes.tagmodaladdbtntxt} /> : <DoneIcon className={classes.tagmodaladdbtntxt} />)}
                      </Button>
                    )}
                    {editTag &&
                      <>
                        &nbsp;
                        <Button variant="contained"
                          type="button"
                          className={classes.tagmodaladdbtn}
                          onClick={() => { handleEditTag(false); handleNewTagName('') }}
                        >
                          <CloseIcon className={classes.tagmodaladdbtntxt} />
                        </Button>
                      </>
                    }
                  </form>
                </Container>
              </DialogContent>
              <DialogActions>
                <Container maxWidth="md" className={classes.tagmodalaction}>
                  {!isShownUpdateTagLoading && (
                    <Button
                      onClick={handleEditTagsParticipants}
                      disabled={isLoadingTags || allTags.length === 0 || !isAllowApply}
                      className={classes.tagmodalactionbtn}
                      style={(isLoadingTags || allTags.length === 0 || !isAllowApply) ? {backgroundColor: "#F0F0F0"} : {}}
                    >
                      Apply
                    </Button>
                  )}
                  {isShownUpdateTagLoading && <Button variant="contained" color="primary" className={classes.tagmodalactionbtn}>
                    <Loading style={{ width: 37, height: 37 }}/>
                  </Button>}
                </Container>
              </DialogActions>
            </Dialog>

            <ImmersionModal
              title={'Are you sure?'}
              description={'Do you really want to delete this tag?'}
              titleOK={'Yes'}
              open={deleteTag ? true : false}
              onApply={handleDeleteTag}
              onClose={() => setDeleteTag('')}
            />
            <Dialog
              disableEscapeKeyDown
              open={isShownDelModal}
              TransitionComponent={Transition}
              keepMounted
              fullWidth={true}
              maxWidth={"md"}
              classes={{
                paper: classes.tagmodalwrap
              }}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle id="alert-dialog-slide-title" onClose={() => {
                setParticipant(initParticipantModel);
                setShownDelModal(false)
              }}>
                {"Remove Participant?"}
              </DialogTitle>
              <Divider />
              <DialogContent style={{ paddingLeft: 0, paddingRight: 0 }}>
                <Container maxWidth="md">
                  <Typography className={classes.delemaildesc}>
                    In most cases, we recommend removing a &quot;measurement&quot; not removing the participant. To learn more about the difference, check out <a className={classes.article} rel="noreferrer" href={`${Config.INTERCOM_URL}/articles/5470631-cleaning-data`} target={'_blank'}>this article</a>.
                    <br /><br />Are you sure you want to remove this participant from this Experience? <br /> This operation cannot be undone.
                  </Typography>
                  <Box className={classes.delemailwrap}>
                    {participant.participant_id ? (
                      <Typography variant="h6" className={classes.delemailtxt}>{participant.temp_email}</Typography>
                    ) : (
                      selRows.map((value, key) => {
                        const labelId = `email-list-label-${key}`;
                        return (
                          <Typography key={labelId} variant="h6" className={classes.delemailtxt}>{value.temp_email}</Typography>
                        );
                      })
                    )}
                  </Box>
                </Container>
              </DialogContent>
              <DialogActions>
                <Container maxWidth="md" className={classes.tagmodalaction}>
                  <Box display="flex" justifyContent="flex-end" alignItems="center">
                    <Box mr={2}>
                      <Button
                        onClick={() => {
                          setParticipant(initParticipantModel);
                          setShownDelModal(false)
                        }
                        }
                        disabled={isLoadingDelParts}
                        variant="contained"
                        className={classes.delemailcancelbtn}
                      >
                        Cancel
                      </Button>
                    </Box>
                    <Button
                      onClick={handleDeleteParticipants}
                      startIcon={isLoadingDelParts && (
                        <Loading style={{ width: 25, height: 25 }}/>
                      )}
                      disabled={isLoadingDelParts}
                      variant="contained"
                      color="secondary"
                      className={classes.delemailbtn}
                    >
                      <span>Delete</span>
                    </Button>
                  </Box>
                </Container>
              </DialogActions>
            </Dialog>
          </div>
          :
          <div className={classes.content}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <div className="card" style={{ display: 'flex' }}>
                  <div>
                    <Skeleton variant="circle" width={120} height={120} />
                  </div>
                  <div style={{ width: '100%', marginLeft: 30 }}>
                    <p className={classes.headerLabel}>Experience Length</p>
                    <Skeleton width={100} />
                    <p className={classes.headerLabel}>Start Date</p>
                    <Skeleton width={100} />
                    <p className={classes.headerLabel}>End Date</p>
                    <Skeleton width={100} />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={8} >
                <div className="card" style={{ display: 'flex' }}>
                  <Grid container spacing={2}>
                    <Grid item sm={3}>
                      <Skeleton variant="circle" width={120} height={120} />
                    </Grid>
                    <Grid item sm={7}>
                      <h3 className={classes.header}>Measurement Status</h3>
                      <Skeleton />
                      <Skeleton />
                      <Skeleton />
                      <Skeleton />
                      <Skeleton />
                    </Grid>
                  </Grid>

                </div>
              </Grid>
              <Grid item xs={12} sm={12} spacing={2}>
                <div className="card">
                  <div className={classes.headerText}>Participant Device Connectivity</div>
                  <div style={{ margin: 20 }}>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                  </div>
                </div>
              </Grid>
            </Grid>

          </div>}

        <CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={isShownSnackAlert} onClose={hideSnackAlert} />
      </div>
    )
  );
}